const state = {
    itens: [],
    item: {
        name: '',
        icon: ''
    }
};

export default state;